module.exports = __webpack_public_path__ + "static/Maria i Jan na ławce na świeżo wytyczonej ulicy w Milanówku-e720c21dd3c9b2b41a4614a711ed571f.jpg";